import customaxios from "../index";

export const getProviderProfileDetails = () => {
  return customaxios({
    method: "GET",
    url: "/provider/profile",
  });
};


export const createProviderProfile = (data: any) => {
  return customaxios({
    method: "POST",
    url: "/provider/profile",
    data,
  });
};

export const updateProviderProfile = (data: any) => {
  return customaxios({
    method: "PUT",
    url: "/provider/profile",
    data,
  });
};

/**
 * ✅ Photo Upload/Delete
 * POST expects multipart/form-data with key: providerProfilePhoto
 */

export const uploadProviderPhoto = (data: FormData) => {
  return customaxios({
    method: "POST",
    url: "/provider/profile/photo",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteProviderPhoto = () => {
  return customaxios({
    method: "DELETE",
    url: "/provider/profile/photo",
  });
};

export const providerChangePassword = (data: URLSearchParams) => {
  return customaxios({
    method: "POST",
    url: "/auth/provider/change-password",
    data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
export const searchPartnerToLink = ({
  type,
  value,
}: {
  type: string;
  value: string;
}) => {
  return customaxios({
    method: "GET",
    url: `/provider/profile/crm-partner/search`,
    params: {
      type,
      value,
    },
  });
};
export const linkPartnerToProvider = (
  id: any,
  crmPartner: {
    id: number;
    companyName: string;
    email: string;
    phoneNumber: string;
  },
) => {
  return customaxios({
    method: "POST",
    url: `/provider/profile/crm-partner/link/${id}`,
    data: {
      crmPartner: crmPartner,
    },
  });
};
